/**
 * #1150: lazy route の chunk ロード中 / 遅延ロケールの初回ロード中に出す
 * 全画面中央 spinner (AdminStampShell と同じ見た目)。
 */
export default function PageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="w-6 h-6 border-2 border-navy border-t-transparent rounded-full animate-spin" />
    </div>
  )
}
